import { PosmExecutionCompletionDeliveryEvidence } from '../../models/posm-execution.models';

export interface CompletionEvidenceScheduleGroup {
    id: number;
    key: string;
    number: string;
    itemName?: string;
    standQty?: number;
    standSize?: string;
    sourceRowNumber?: number;
    assets: PosmExecutionCompletionDeliveryEvidence[];
}
export interface CompletionEvidenceLocationGroup {
    key: string;
    name: string;
    schedules: CompletionEvidenceScheduleGroup[];
    assetCount: number;
}
export function completionEvidenceKey(asset: PosmExecutionCompletionDeliveryEvidence): string {
    return `${asset.deliveryScheduleId ?? 'unmapped'}:${asset.sourceType}:${asset.sourceId}`;
}
export function groupCompletionEvidence(assets: PosmExecutionCompletionDeliveryEvidence[]): CompletionEvidenceLocationGroup[] {
    const groups = new Map<string, CompletionEvidenceLocationGroup>();
    for (const asset of assets) {
        if (!asset.deliveryScheduleId || asset.mappingStatus !== 'MAPPED') continue;
        const key = asset.locationId ? `location:${asset.locationId}`
            : asset.storeId ? `store:${asset.storeId}` : `schedule:${asset.deliveryScheduleId}`;
        const group = groups.get(key) ?? { key, name: asset.locationName || 'Location not linked', schedules: [], assetCount: 0 };
        let schedule = group.schedules.find(item => item.id === asset.deliveryScheduleId);
        if (!schedule) {
            schedule = { id: asset.deliveryScheduleId, key: `${key}:${asset.deliveryScheduleId}`,
                number: asset.scheduleNumber || `Schedule #${asset.deliveryScheduleId}`,
                itemName: asset.itemName, standQty: asset.standQty, standSize: asset.standSize,
                sourceRowNumber: asset.sourceRowNumber, assets: [] };
            group.schedules.push(schedule);
        }
        if (!schedule.assets.some(existing => completionEvidenceKey(existing) === completionEvidenceKey(asset))) {
            schedule.assets.push(asset);
            group.assetCount++;
        }
        groups.set(key, group);
    }
    const result = [...groups.values()].sort((a, b) => a.name.localeCompare(b.name) || a.key.localeCompare(b.key));
    result.forEach(group => {
        group.schedules.sort((a, b) => (a.sourceRowNumber ?? Number.MAX_SAFE_INTEGER) - (b.sourceRowNumber ?? Number.MAX_SAFE_INTEGER) || a.id - b.id);
        group.schedules.forEach(schedule => schedule.assets.sort((a, b) =>
            (b.uploadedAt ? new Date(b.uploadedAt).getTime() : 0) - (a.uploadedAt ? new Date(a.uploadedAt).getTime() : 0)
            || (a.sourceId || 0) - (b.sourceId || 0)
            || (a.sourceType || '').localeCompare(b.sourceType || '')));
    });
    return result;
}
